import soxKendoPanelBar from './sox';

export default function() {
    fetchBrevData($("[data-for-exception='B.REV.12']"));
}

const fetchBrevData = $container => {
    if ($container.length) {
        $container.load('/Account/Dashboard/Brev12', { isReview: window.location.href.indexOf('SoxReview') !== -1 }, function(response) {
            // re-run PanelBar stuff
            soxKendoPanelBar($('.pannelbar--soxstatus'));
        });
    }
};
